import fetch from "../helpers/fetch";

const getAccreditationAgencies = () =>
  fetch('/api/accreditation-agencies/all', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const postAccreditationAgencies = accreditationAgency =>
  fetch('/api/accreditation-agency/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(accreditationAgency),
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const putAccreditationAgency = ({ uuid, ...updates }) =>
  fetch(`/api/accreditation-agency/${uuid}/update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(updates)
  })
    .then(res => res)
    .catch(error => {
      throw error;
    });

const deleteAccreditationAgency = uuid =>
  fetch(`/api/accreditation-agency/${uuid}/delete`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  })
    .then(res => res)
    .catch(error => error);

export {
  getAccreditationAgencies,
  postAccreditationAgencies,
  putAccreditationAgency,
  deleteAccreditationAgency
};
